export const DEFAULT_END_TIME = "23:59"
export const PLANNING_NEWS = "PLANNING_NEWS "
export const SHOWING_NEWS = "SHOWING_NEWS "
export type NewsType = typeof PLANNING_NEWS | typeof SHOWING_NEWS
export const validTimeRegex = /^([01]\d|2[0-3]):[0-5]\d$/
export const validTimeWhileTypingRegex = /^(?:(?:[01]?\d|2[0-3])(?::[0-5]?\d?)?|(?:[01]\d|2[0-3])[0-5]\d?)?$/
